// import getErrorMessage from '@/utils/getErrorMessage';

export default function queryErrorHandler(error: any) {
  const { status } = error.response || { status: null };

  if (!error.success) {
    throw error;
  }

  switch (status) {
    // TODO: status 코드별 처리 필요여부 체크
    // 토큰 만료시 권한에러
    // TODO: 추후(다음 프로젝트) 리프레시 토큰 쿠키에 담아서 처리예정
    case 401: {
      // alert('권한이 없습니다. 로그인이 필요합니다.');
      window.location.href = '/admin';
      break;
    }
    default: {
      // alert(getErrorMessage(error.response?.data.message));
      // console.log(getErrorMessage(error.response?.data.message));
      break;
    }
  }

  return null;
}
